import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, TextInput, Filter, FunctionField, Show, SimpleShowLayout, ArrayField, NumberField, ReferenceField, RefreshButton } from 'react-admin';
import { Create, SimpleForm, ReferenceInput, SelectInput, required, Edit, SaveButton, Toolbar, EditButton, usePermissions } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    sanitizeListRestProps,
} from 'react-admin';
import { parse } from "query-string";
import TestButtonWithConfirmation from '../buttons/testButtonWithConfirmation';
import QrCodeGenerator from './qrCode';
import CircleIcon from '@material-ui/icons/FiberManualRecord';
import EmptyCircleIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Redirect } from 'react-router-dom';

// import { useFormState } from 'react-final-form';
// import { renameProps } from 'recompose';


const styles = {
    div1: {
        display: 'block',
        width: "25%",
        float: "left",
        position: "flex",
        marginRight: "10px"
    },
    div1Mobile: {
        display: 'block',
        width: "50%",
        float: "left",
        position: "flex",
        marginLeft: "2%",
        marginRight: "2%"
    },
    div2: {
        display: 'block',
        width: "74%",
        float: "left",
        position: "flex"
    },
    div2Mobile: {
        display: 'block',
        width: "100%",
        float: "left",
        marginLeft: "2%",
        marginRight: "2%",
        marginTop: "2%",
        position: "flex"
    },
    table: {
        overflowX: "auto"
    }
};

const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("machines.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("machines.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
        </TopToolbar>
    );
};

function codeValidation(code) {
    if (/^[Aa][Cc][Tt]\.[Ee][Qq]-(?!0000)\d{4}(?!\d)/.test(code)) {
        return null;
    }
    return "Código no cumple el formato ACT.EQ-1234";
}

const MachineTitle = ({ record, optionTitle }) => {
    if (optionTitle) {
        return ""
    }
    return <span>Máquina - {record ? `${record.code}` : ''}</span>;
};

export const MachineList = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <List filters={<MachineFilter />} {...props} title="Máquinas" actions={<ListActions />}>
            <Datagrid rowClick="show">
                <TextField source="code" label='Código' />
                {(permissions.includes("buildings.list")) &&
                    <ReferenceField source="buildingId" label='Edificio' reference="buildings" link="show">
                        <TextField label="Dirección" source="address" link="show" />
                    </ReferenceField>
                }
                <FunctionField render={record => `${record.type.toUpperCase()}`} label='Tipo de máquina' />
                <FunctionField render={record => `${record.secondType.toUpperCase()}`} label='Origen' />
                <FunctionField render={record => {
                    if (record.valid === 'true') {
                        return 'Activa';
                    } else {
                        if (record.repair === 'true' || record.repair === true) {
                            return 'En reparación';
                        }
                    }
                    return 'Inactiva';
                }} label='Estado' />
                <FunctionField render={record => {
                    if (record.lastStart) {
                        const date = Date.parse(record.lastStart);
                        let numero = date;
                        numero += record.lastDuration * 60000;
                        const now = new Date();
                        const diff = numero - now.getTime();
                        const diffMinutes = diff / (1000 * 60);
                        if (0 < diffMinutes && diffMinutes < 10) {
                            return "Por terminar"
                        } else if (numero > now.getTime()) {
                            return "Ocupada"
                        } else {
                            return "Disponible"
                        }
                    }
                }} label='Actividad' />
                <FunctionField render={record => {
                    if (record.repair === 'true' || record.repair === true) {
                        return <CircleIcon style={{ color: 'black' }} />;
                    }
                    if (record.valid !== 'true') {
                        return <EmptyCircleIcon style={{ color: 'black' }} />
                    }
                    if (record.lastConnection) {
                        const date = Date.parse(record.lastConnection);
                        let numero = date;
                        const now = new Date();
                        const diff = numero - now.getTime();
                        const diffMinutes = Math.abs(diff / (1000 * 60));
                        if (5 < diffMinutes && diffMinutes < 10) {
                            return <CircleIcon style={{ color: 'yellow' }} />
                        } else if (60 > diffMinutes && diffMinutes > 9) {
                            return <CircleIcon style={{ color: 'red' }} />
                        } else if (diffMinutes >= 60) {
                            return <p><CircleIcon style={{ color: 'red' }} /><CircleIcon style={{ color: 'red' }} /></p>
                        } else {
                            return <CircleIcon style={{ color: 'green' }} />
                        }

                    } else {
                        return <p><CircleIcon style={{ color: 'red' }} /><CircleIcon style={{ color: 'red' }} /></p>
                    }
                }} label='Internet' />
                <FunctionField render={record => {
                    if (record.lastConnection) {
                        const date = Date.parse(record.lastConnection);
                        let numero = date;
                        const now = new Date();
                        // calculates amout of hours since record.lastConnection
                        const diff = numero - now.getTime();
                        const diffHours = Math.abs(diff / (1000 * 60 * 60));
                        if (diffHours.toFixed(1) > 0.5) {
                            return diffHours.toFixed(1);
                        }
                    }
                    return "";
                }} label='Horas desde última conexión' />

            </Datagrid>
        </List>
    )
};

export const MachineShow = props => {
    const [width, setWindowWidth] = useState(0)

    useEffect(() => {

        updateDimensions();

        window.addEventListener("resize", updateDimensions);
        return () =>
            window.removeEventListener("resize", updateDimensions);
    }, [])
    const updateDimensions = () => {
        const width = window.innerWidth
        setWindowWidth(width)
    }

    const responsive = {
        web: width > 1023
    }

    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }

    return (

        <div>
            <div style={(responsive.web) ? styles.div1 : styles.div1Mobile}>
                <Show {...props} title={<MachineTitle />} actions={<MachineShowActions f={false} edit={true} />}>
                    <SimpleShowLayout>
                        <TextField source="id" />
                        <TextField source="code" label='Código' />
                        <FunctionField render={record => {
                            if (record.valid === 'true') {
                                return 'Activa';
                            } else {
                                if (record.repair === 'true' || record.repair === true) {
                                    return 'En reparación';
                                }
                            }
                            return 'Inactiva';
                        }} label='Estado' />
                        {(permissions.includes("buildings.list")) &&
                            <ReferenceField source="buildingId" label='Edificio' reference="buildings" link="show">
                                <TextField label="Dirección" source="address" link="show" />
                            </ReferenceField>
                        }
                        <FunctionField render={record => `${record.type.toUpperCase()}`} label='Tipo de máquina' />
                        <FunctionField render={record => `${record.secondType.toUpperCase()}`} label='Origen' />
                        <FunctionField render={record => `${(record.lastStart) ? record.lastStart : "No registrado"}`} label='Último uso' />
                        <FunctionField render={record => `${(record.lastDuration) ? record.lastDuration : "No registrado"}`} label='Última duración' />
                        <FunctionField render={record => {
                            if (record.lastStart) {
                                const date = Date.parse(record.lastStart);
                                let numero = date;
                                numero += record.lastDuration * 60000;
                                const now = new Date();
                                const diff = numero - now.getTime();
                                const diffMinutes = diff / (1000 * 60);
                                if (0 < diffMinutes && diffMinutes < 10) {
                                    return "Por terminar"
                                } else if (numero > now.getTime()) {
                                    return "Ocupada"
                                } else {
                                    return "Disponible"
                                }
                            }
                        }} label='Actividad' />
                        <FunctionField render={record => `${(record.lastConnection) ? record.lastConnection : "-"}`} label='Última conexión internet' />
                        <FunctionField render={record => {
                            if (record.repair === 'true' || record.repair === true) {
                                return <CircleIcon style={{ color: 'black' }} />;
                            }
                            if (record.valid !== 'true') {
                                return <EmptyCircleIcon style={{ color: 'black' }} />
                            }
                            if (record.lastConnection) {
                                const date = Date.parse(record.lastConnection);
                                let numero = date;
                                const now = new Date();
                                const diff = numero - now.getTime();
                                const diffMinutes = Math.abs(diff / (1000 * 60));
                                console.log(diffMinutes);
                                if (5 < diffMinutes && diffMinutes < 10) {
                                    return <CircleIcon style={{ color: 'yellow' }} />
                                } else if (60 > diffMinutes && diffMinutes > 9) {
                                    return <CircleIcon style={{ color: 'red' }} />
                                } else if (diffMinutes >= 60) {
                                    return <p><CircleIcon style={{ color: 'red' }} /><CircleIcon style={{ color: 'red' }} /></p>
                                } else {
                                    return <CircleIcon style={{ color: 'green' }} />
                                }

                            } else {
                                return <p><CircleIcon style={{ color: 'red' }} /><CircleIcon style={{ color: 'red' }} /></p>
                            }
                        }} label='Internet' />
                        <FunctionField render={record => {
                            if (record.lastConnection) {
                                const date = Date.parse(record.lastConnection);
                                let numero = date;
                                const now = new Date();
                                // calculates amout of hours since record.lastConnection
                                const diff = numero - now.getTime();
                                const diffHours = Math.abs(diff / (1000 * 60 * 60));
                                if (diffHours.toFixed(1) > 0.5) {
                                    return diffHours.toFixed(1);
                                }
                            }
                            return "";
                        }} label='Horas desde última conexión' />
                    </SimpleShowLayout>
                </Show>
                {(permissions.includes("transactions.test")) &&
                    <Show {...props} title={<MachineTitle optionTitle={true} />} actions={<MachineShowActions f={false} />}>
                        <SimpleShowLayout>
                            <TestButtonWithConfirmation />
                        </SimpleShowLayout>
                    </Show>
                }
                <Show {...props} title={<MachineTitle optionTitle={true} />} actions={<MachineShowActions f={false} />}>
                    <SimpleShowLayout>
                        <QrCodeGenerator />
                    </SimpleShowLayout>
                </Show>
                {(permissions.includes("prices.list")) &&
                    <Show {...props} title={<MachineTitle optionTitle={true} />} actions={<MachineShowActions f={false} />}>
                        <SimpleShowLayout>
                            <ArrayField source="prices" label="Precios asociados" fieldKey="priceId">
                                <Datagrid>
                                    <TextField source="type" label="Nombre" />
                                    <NumberField source="price" label="Monto" />
                                    <NumberField source="pricePeakHour" label="Monto hora punta" />
                                    <NumberField source="ticks" label="Pulsos" />
                                </Datagrid>
                            </ArrayField>
                        </SimpleShowLayout>
                    </Show>
                }
            </div>
            <div style={(responsive.web) ? styles.div2 : styles.div2Mobile}>
                {(permissions.includes("transactions.list")) &&
                    <Show {...props} title={<MachineTitle optionTitle={true} />} actions={<MachineShowActions edit={false} />}>
                        <SimpleShowLayout>
                            <RefreshButton label="Buscar transacciones" />
                            <ArrayField source="transactions" label="Transacciones (se muestran las últimas 25 transacciones)" fieldKey="transactionId">
                                <Datagrid>
                                    <TextField source="amount" label="Monto" />
                                    <NumberField source="transactionId" label="Id" />
                                    {(permissions.includes("users.list")) ?
                                        <ReferenceField source="userId" label='Usuario' reference="users" link="show">
                                            <FunctionField label="Nombre completo" render={record => `${record.firstname} ${record.lastname}`} link="show" />
                                        </ReferenceField>
                                        : null}
                                    <TextField source="createdAt" label="Fecha" />
                                </Datagrid>
                            </ArrayField>
                            <button onClick={() => props.history.push(`/transactions?page=1&perPage=25&filter={"machineId":"${props.id}"}`)}>Mostrar más transacciones</button>
                        </SimpleShowLayout>
                    </Show>
                }
            </div>
        </div>
    )
};

const MachineFilter = (props) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <Filter {...props}>
            <TextInput label="Buscar" source="q" alwaysOn />
            <SelectInput source="valid" label="Estado" choices={[
                { id: 'active', name: 'Activa' },
                { id: 'inactive', name: 'Inactiva' },
                { id: 'repair', name: 'En reparación' }
            ]} />

            {permissions.includes("machine_types.list") &&
                <ReferenceInput validate={[required()]} source="typeId" label='Tipo de máquina' reference="machine_types" perPage={200}
                    sort={{ field: 'id', order: 'ASC' }}
                >
                    <SelectInput optionText={record => `${capitalizarPrimeraLetra(record.type)} - ${record.secondType}`} />
                </ReferenceInput>
            }
        </Filter>
    )
};

const MachineEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

function capitalizarPrimeraLetra(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const MachineEdit = props => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("machine_types.list") || !permissions.includes("buildings.list")) {
        return <Redirect to="/401" />
    }
    return (<Edit {...props}>
        <SimpleForm submitOnEnter={false} toolbar={<MachineEditToolbar />}>
            {(permissions.includes("machine_types.list")) &&
                <ReferenceInput validate={[required()]} source="typeId" label='Tipo de máquina (en progreso)' reference="machine_types" perPage={200}
                    sort={{ field: 'id', order: 'ASC' }}
                >
                    <SelectInput optionText={record => `${capitalizarPrimeraLetra(record.type)} - ${record.secondType}`} />
                </ReferenceInput>
            }
            {permissions.includes("buildings.list") &&
                <ReferenceInput validate={[required()]} source="buildingId" label='Edificio' reference="buildings" perPage={200}
                    sort={{ field: 'id', order: 'DESC' }}
                >
                    <SelectInput optionText={record => `${record.id}.- ${record.address}`} />
                </ReferenceInput>
            }
            <FunctionField render={record => {
                if (record.valid === 'true') {
                    return 'Activa';
                } else {
                    if (record.repair === 'true' || record.repair === true) {
                        return 'En reparación';
                    }
                }
                return 'Inactiva';
            }} label='Estado actual' />
            <SelectInput validate={[required()]} source="valid" label="Nuevo estado de máquina" choices={[
                { id: 'active', name: 'Activa' },
                { id: 'inactive', name: 'Inactiva' },
                { id: 'repair', name: 'En reparación' }
            ]} />
        </SimpleForm>
    </Edit>)
};

export const MachineCreate = props => {
    const { buildingId: building_id } = parse(props.location.search);
    const buildingId = building_id ? parseInt(building_id, 10) : "";
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if (!permissions.includes("machine_types.list") || !permissions.includes("buildings.list")) {
        return <Redirect to="/401" />
    }
    return (<Create {...props}>
        <SimpleForm defaultValue={{ buildingId }} submitOnEnter={false}>
            <TextInput validate={[required(), codeValidation]} source="code" label='Código de la máquina' />
            {permissions.includes("machine_types.list") &&
                <ReferenceInput validate={[required()]} source="typeId" label='Tipo de máquina' reference="machine_types" perPage={200}
                    sort={{ field: 'id', order: 'ASC' }}
                >
                    <SelectInput optionText={record => `${capitalizarPrimeraLetra(record.type)} - ${record.secondType}`} />
                </ReferenceInput>
            }
            {permissions.includes("buildings.list") &&
                <ReferenceInput validate={[required()]} source="buildingId" label='Edificio' reference="buildings" perPage={200}
                    sort={{ field: 'id', order: 'DESC' }}
                >
                    <SelectInput optionText={record => `${record.id}.- ${record.address}`} />
                </ReferenceInput>
            }
            <SelectInput validate={[required()]} source="valid" label="Estado de máquina" choices={[
                { id: 'active', name: 'Activa' },
                { id: 'inactive', name: 'Inactiva' },
                { id: 'repair', name: 'En reparación' }
            ]} />
        </SimpleForm>
    </Create>)
};

const MachineShowActions = ({ basePath, data, resource, edit = false, f = false }) => {
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    if ((edit || f) && permissions.includes("machines.edit")) {
        return (
            <TopToolbar>
                {(edit) ? <EditButton basePath={basePath} record={data} label="Editar máquina" /> : null}
            </TopToolbar>
        )
    }
    return (<p></p>)
}
